<section class="meal-solution">
  <div class="meal-wrapper">
    <div class="meal-content">
      <div class="meal-text">
        <h2><span class="highlight" [innerHTML]="title"></span></h2>
        <p>
          {{ description }}
        </p>
      </div>
    </div>
  </div>
</section>
